import React, { useEffect, useState } from "react";
import ArrowLeft from "../assets/img/arrow-left.svg";
import { Link, useParams } from "react-router-dom";
import Button from "../components/Button";
import CheckNube from "../assets/img/check-nube.svg";
import { useNavigate } from "react-router-dom";
import { usePost } from "../hooks";
import { fireGenericErrorModal, firePostSuccessModal } from "../utils/swals";
import {
  getDDMMFormat,
  getHHMMFormat,
  getDDMMHHmmFormat,
} from "../utils/dates";
import { SignOut } from "../utils/auth";
import { usePartido } from "../context/PartidoContext";
const AcreditacionesFotografo = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [id]);
  const { postJson, isLoading } = usePost();
  const { selectedPartido, setSelectedPartido } = usePartido();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    categoria,
    subcategoria,
    fotoEquipo1,
    fotoEquipo2,
    nombreEvento,
    inicioAcreditacion,
    finAcreditacion,
    fotoIconoDeporte,
    lugar,
    fecha,
  } = selectedPartido || {};

  const fechaDate = new Date(fecha);
  const inicioAcreditacionDate = new Date(inicioAcreditacion);
  const finAcreditacionDate = new Date(finAcreditacion);

  const handleSubmit = async () => {
    if (isSubmitting || isLoading) return;
    setIsSubmitting(true);

    try {
      const result = await postJson("/crear-solicitud-f", {
        idEvento: id,
      });

      if (result.status === "KO") {
        fireGenericErrorModal();
      } else {
        firePostSuccessModal(
          () => {
            setSelectedPartido(null);
            SignOut();
            navigate("/");
          },
          result.solicitud_id,
          false
        );
      }
    } catch (error) {
      fireGenericErrorModal(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="back-gray">
      <div className="acreditaciones-fotografo">
        <Link to={"/"} className="volver">
          <img src={ArrowLeft} alt="" />
          <h6>Volver a Próximos eventos</h6>
        </Link>
        <div className="acr-fot">
          <div className="pcat fotografo">
            <img
              src={fotoIconoDeporte}
              alt=""
              style={{ width: "40px", height: "40px" }}
            />
            <div className="d-flex align-items-center">
              <span>{categoria}</span>
              <div className="vline"></div>
              <p>{subcategoria}</p>
            </div>
          </div>
          <h5>
            <span className="fw400">EVENTO </span>
            {nombreEvento}
          </h5>
          <div className="equipos">
            <img src={fotoEquipo1} alt="Escudo de river" />
            <span>VS</span>
            <img src={fotoEquipo2} alt="Colo colo" />
          </div>
          <p className="fot-info">{lugar}</p>
          <p className="fot-info">
            {getDDMMFormat(fechaDate)} | {getHHMMFormat(fechaDate)}hs
          </p>
          <div className="af-info">
            <div className="acred">
              <div className="icono-texto">
                <img src={CheckNube} alt="" />
                <p>Acreditaciones</p>
              </div>
              <div className="fechas-acred">
                <div className="texto-flecha">
                  <p>COMIENZO</p>
                  <p>→</p>
                  <p>{getDDMMHHmmFormat(inicioAcreditacionDate)}</p>
                </div>
                <div className="texto-flecha">
                  <p>FIN</p>
                  <p>→</p>
                  <p>{getDDMMHHmmFormat(finAcreditacionDate)}</p>
                </div>
              </div>
            </div>
            {/* <div className="vline"></div> */}
            {/* <div>
              <div className="icono-texto">
                <img src={Geo} alt="" />
                <p>Accesos</p>
              </div>
              <p className="descripcion-af">
                Deberá acceder desde la entrada X ubicada en Calle 123 entre
                Lorem Ipsum y Dolor Sit. Deberá validar su ingreso en el
                molinete H lorem ipsum dolor sit amet contrete.
              </p>
            </div> */}
          </div>
          <div className="button-group">
            <Button
              variant={"outline-btn"}
              onClick={() => navigate("/")}
            >
              Cancelar
            </Button>
            <Button
              variant={`login-btn ${!isLoading && !isSubmitting && "enabled"}`}
              isDisabled={isLoading || isSubmitting}
              onClick={handleSubmit}
            >
              Confirmar acreditacion
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AcreditacionesFotografo;
